export default {
  id: 10,
  pride: 40960,
  slug: "playground-tower-space-elevator",
  series: "beyond-books",
  category: "novel",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "操场·高楼·太空电梯",
    en: "Playground, Tower, Space Elevator"
  },
  image: require('@/assets/images/playground.webp'),
  descriptionKey: {
    zh: "超短篇科幻小说。《不止于纸上的故事》中的一个短篇。",
    en: "Ultra-short sci-fi novel. A short story from 'Beyond Books'."
  },
  date: { year: 2021, month: 6 },
  genres: ["超短篇", "科幻"],
  themes: ["告别与传承", "科技与未来", "情感与羁绊"],
  scale: {
    zh: "约 5,000 字",
    en: "Approx. 5,000 words"
  },
  developerNotesKey: {
    zh: "已发布于同名B站专栏。可在下方链接阅读。",
    en: "Published in the Bilibili column of the same name. Can be read via the link below."
  },
  tags: ["小说"],
  longDescriptionKey: {
    zh: "置身于【2112年】的近未来，站在全球最高建筑的云顶操场，见证一个时代的壮丽落幕。由于神秘的【异能枯竭事件】，曾依靠【灵能】驱动的【太空电梯】——那道连接天地的「光柱」，即将执行其最后一次运载任务。\n\n你将跟随乐观活泼的维持员【惠】、经验丰富的发射员【蝎子】，与她们一同送别那位特殊的【客人】，并与充满好奇心的年轻记者【寻叶】一起记录这历史一刻。在这部短篇中，你将体验到：\n\n- 最后一次【太空电梯】升空旅程的独特感受，从地面直冲云霄，体验失重，俯瞰脚下如宣纸般平坦的大地与弧形的地平线。\n- 角色间温暖的日常互动与生死一瞬中紧握的双手，感受【惠】与【蝎子】的深厚友情，以及【惠】与【客人】之间难以言说的默契与情感。\n- 【灵能】在仪式般的告别中使用，见识【灵能糖】的神奇效用，以及能力者们在限制下的生活点滴。\n- 从惊心动魄的超高速返回引发的「意外」，到对【神舟货运】、【天问探索】等未来星辰大海征途的无限向往。\n\n这不仅是一个关于科技更迭的科幻故事，更是一曲关于告别旧日、珍视当下情感，并勇敢展望未来的温情诗篇。",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/read/cv11529157/", textKey: { zh: "B站专栏阅读", en: "Read on Bilibili Column" } }
  ]
};
